import React, { useEffect, useState } from 'react';

export const ImageContent = ({ fileBlob }: { fileBlob: Blob | null }) => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);

    useEffect(() => {
        if (fileBlob) {
            const objectUrl = URL.createObjectURL(fileBlob);
            setImageSrc(objectUrl);

            return () => {
                URL.revokeObjectURL(objectUrl);
            };
        }
        return undefined;
    }, [fileBlob]);

    if (!imageSrc) {
        return <div>Loading...</div>;
    }

    return (
        <img
            src={imageSrc}
            alt="content"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                display: 'block',
            }}
        />
    );
};
